import {cnpj, cpf} from 'cpf-cnpj-validator';
import { maskArray } from 'react-text-mask';

export const validCnpjCpf = (value: string): boolean => {
    if (value.length >= 15) {
        return cnpj.isValid(value);
    } else {
        return cpf.isValid(value);
    }
}

export const cnpjCpfMask = (value: string): maskArray => {
    var maskCpfCnpj;

    if (value.length >= 15) {
        maskCpfCnpj = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/,];
    } else {
        maskCpfCnpj = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/,];
    }

    return maskCpfCnpj;
}